<template>
  <div>
    <v-row>
      <v-col class="pb-0" cols="12">
        <h3 class="my-5 section-title">{{ title }}</h3>
      </v-col>

      <mf-toggle v-model="couponsLimit.active" class="ml-4 mb-3" hide-details label="Limite de compras" @change="updateCouponsLimit(updateLimitMessage)" />
    </v-row>
    <mf-card-container title="Limite de compras" :description="descriptionText">
      <v-row>
        <v-col cols="3">
          <mf-number-input
            v-model="couponsLimit.limit_per_day"
            label="Limite de compras por dia"
            outlined
            :value="couponsLimit.limit_per_day"
            :min="1"
            :max="100"
            :disabled="!couponsLimit.active"
            :error="showLimitError"
            :error-messages="errorMessages"
            @input="showSaveButton"
          />
        </v-col>
      </v-row>
      <mf-action-buttons
        :primary-button="{
          text: 'Salvar',
          action: () => updateCouponsLimit(updateLimitMessage),
          isVisible: true,
          isDisabled: !couponsLimit.active,
        }"
      />
    </mf-card-container>
  </div>
</template>

<script>
import { pointsOrCashback } from '../../../mixins/points-or-cashback'

export default {
  name: 'VoucherCpfPointsLimit',
  mixins: [pointsOrCashback],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    saveButtonEnable: false,
    updateLimitMessage: 'Limite de compras atualizado com sucesso.',
    showLimitError: false,
  }),
  computed: {
    couponsLimit: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    title() {
      return `Limitação da distribuição de ${this.pointsText}`
    },
    descriptionText() {
      return `Todas as compras de um mesmo CPF, num mesmo dia que passem do limite diário definido aqui, não creditarão ${this.pointsText}. Os cupons feitos no dia da alteração
        vão ser calculados com o último valor inserido.`
    },
    errorMessages() {
      return this.showLimitError ? `Campo obrigatório. Para desativar o limite diário, desabilite a opção acima chamada "Limite de compras".` : ''
    },
  },
  watch: {
    couponsLimit: {
      deep: true,
      handler() {
        this.showLimitError = false
      },
    },
  },
  methods: {
    showSaveButton() {
      this.saveButtonEnable = true
    },
    updateCouponsLimit(message) {
      if (this.couponsLimit.limit_per_day < 1 || !this.couponsLimit.limit_per_day) {
        this.showLimitError = true
        return
      }
      this.$emit('update-limits', message)
    },
  },
}
</script>

<style lang="scss">
.text-style {
  word-break: normal;
  line-height: 21px;
}
</style>
